"use client";

import { useEmployeeInfo } from "@/modules/hooks/employee/useEmployeeInfo";
import { EmployeeInfo } from "@/modules/types/employee/employee";
import { useEffect } from "react";
import { EmployeeInfoContext } from "./EmployeeInfoContext";
import { setAnalyticsUser } from "@/lib/analytics";

export default function CheckAuthProvider({
  strictCheck = false,
  employeeInfoServerProps,
  children,
}: {
  strictCheck?: boolean;
  employeeInfoServerProps?: EmployeeInfo | null;
  children?: React.ReactNode;
}) {
  const { employeeInfo, getEmployeeInfo, setEmployeeInfo } =
    useEmployeeInfo(strictCheck);

  useEffect(() => {
    if (employeeInfoServerProps !== undefined) {
      setEmployeeInfo(employeeInfoServerProps);
      if (employeeInfoServerProps) {
        const authId =
          (employeeInfoServerProps as any)?.auth_id ||
          (employeeInfoServerProps as any)?.authId ||
          employeeInfoServerProps.id;
        if (authId) {
          setAnalyticsUser(authId);
        }
      }
    } else if (employeeInfo === undefined) {
      getEmployeeInfo();
    }
  }, [employeeInfoServerProps, setEmployeeInfo]);

  return (
    <EmployeeInfoContext.Provider value={employeeInfoServerProps}>
      {children}
    </EmployeeInfoContext.Provider>
  );
}
